import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sheet, Typography, Box, Grid, Button } from '@mui/joy';
import {
    MonitorHeart,
    Videocam,
    CheckCircle,
    Psychology,
    Timeline,
    Email,
    ArrowBack,
} from '@mui/icons-material';
import BranchCard from '../components/dashboard/BranchCard';
import { TOOL_URLS, openTool } from '../config/tools';

const tools = [
    {
        id: 'system-monitoring',
        title: 'System Monitoring',
        description: 'Cloud service uptime and health dashboard (Gatus)',
        icon: MonitorHeart,
        color: 'success',
        url: TOOL_URLS.systemMonitoring,
    },
    {
        id: 'data-collector',
        title: 'Data Collector',
        description: 'Record venue camera streams and export datasets to VT',
        icon: Videocam,
        color: 'warning',
        url: TOOL_URLS.dataCollector,
    },
    {
        id: 'verification-tool',
        title: 'Verification Tool',
        description: 'Datasets, ground truth, verification runs and reports',
        icon: CheckCircle,
        color: 'primary',
        url: TOOL_URLS.verificationTool,
    },
    {
        id: 'annotation-tool',
        title: 'Annotation Tool',
        description: 'Label recordings and produce ground-truth bundles',
        icon: Psychology,
        color: 'neutral',
        url: TOOL_URLS.annotationTool,
        badge: 'Coming Soon',
        // Stay disabled until a production URL is configured.
        disabled: !TOOL_URLS.annotationTool,
    },
    {
        id: 'observability',
        title: 'Observability Tool',
        description: 'Metrics and logs dashboards (Grafana)',
        icon: Timeline,
        color: 'danger',
        url: TOOL_URLS.observability,
    },
    {
        id: 'landing-admin',
        title: 'Landing Admin Portal',
        description: 'Beta enrollments and landing-page administration',
        icon: Email,
        color: 'primary',
        url: TOOL_URLS.landingAdmin,
    },
];

const ToolsPage = () => {
    const navigate = useNavigate();

    return (
        <Sheet sx={{ p: 4, maxWidth: '1400px', mx: 'auto' }}>
            <Box sx={{ mb: 4 }}>
                <Button
                    variant="plain"
                    color="neutral"
                    startDecorator={<ArrowBack />}
                    onClick={() => navigate('/admin')}
                    sx={{ mb: 2, px: 0 }}
                >
                    Back to Dashboard
                </Button>
                <Typography level="h2" sx={{ mb: 1 }}>
                    Tools
                </Typography>
                <Typography level="body-lg" textColor="neutral.600">
                    Open AI Hub operator tools in a new window
                </Typography>
            </Box>

            <Grid container spacing={4} sx={{ alignItems: 'stretch' }}>
                {tools.map((tool) => {
                    const disabled = Boolean(tool.disabled) || !tool.url;
                    return (
                        <Grid key={tool.id} xs={12} sm={6} lg={4} sx={{ display: 'flex' }}>
                            <Box sx={{ width: '100%', display: 'flex' }}>
                                <BranchCard
                                    title={tool.title}
                                    description={tool.description}
                                    icon={tool.icon}
                                    color={tool.color}
                                    badge={tool.badge}
                                    disabled={disabled}
                                    onClick={() => openTool(tool.url)}
                                />
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Sheet>
    );
};

export default ToolsPage;
